export const mockOutputView = [
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1002580",
    "Material Description": "S650     ***************80% BK XZX00000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.22",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "594,000.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "-0.04%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "MIGUEL VISO",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1709595",
    "Material Description": "S7033L   ***************DS  BK ZFA00000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "1.00",
    "Coverage Profile (wk) - Approved": "1.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "MIGUEL VISO",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1002866",
    "Material Description": "S801***************    BK XFX00000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.63",
    "Coverage Profile (wk) - Approved": "1.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "48,000.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.05%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1003056",
    "Material Description": "S7022L***************SS     XFA1200",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "1.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "MOQ - Change won't  Effect ",
    "Approver": "MIGUEL VISO",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1017049",
    "Material Description": "FILTER AID HYFLO SUPERCEL",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "2.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1172242",
    "Material Description": "MAG CARB LIGHT           XFX       20",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "6.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1426852",
    "Material Description": "S7029L***************SS  DR ZFA25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "\n",
    "Approver": "MIGUEL VISO",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1513094",
    "Material Description": "S7027***************       XFA1200",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "4.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "MOQ- Changes won't effect ",
    "Approver": "MIGUEL VISO",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1631478",
    "Material Description": "S801***************95.0   PFX788",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.20",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.20",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.20",
    "VAR (%) - Approved SS vs S4": "5.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "no changes needed as per IO",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1709596",
    "Material Description": "S7033L***************DS  BKLPFA00000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "MIGUEL VISO",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "1709597",
    "Material Description": "S7033L***************DS  BK KFA00000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.42",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "3,200.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "-0.68%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "MIGUEL VISO",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "3005325",
    "Material Description": "S801***************       XFX805.9",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "2.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Andrea Pradeep",
    "Material Plant": "5040",
    "Material Number": "3035503",
    "Material Description": "S801***************96% IB KFX805",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "3",
    "Writeback Date": "10/23/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "2036081",
    "Material Description": "S2438.1  ***************    PK ZFZ230",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "3.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.00",
    "VAR (%) - Approved SS vs S4": "-40.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "2099529",
    "Material Description": "S2428.5  ***************    IB XFX907.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "8.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "8.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-5.22",
    "VAR (%) - Approved SS vs S4": "-38.05%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1924220",
    "Material Description": "S3178.9  ***************       ZFX900",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "3.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002582",
    "Material Description": "S1265***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "2.00",
    "VAR (%) - Approved SS vs S4": "100.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "LUCY LI",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002616",
    "Material Description": "S1405*************** N2    XFX5",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "4.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Keep S4 Parameters\n",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002617",
    "Material Description": "S3555***************       ZFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.50",
    "VAR (%) - Approved SS vs S4": "-50.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002619",
    "Material Description": "S3168***************       ZFX46",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.07",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "6.07",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-0.50",
    "VAR (%) - Approved SS vs S4": "-7.61%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002691",
    "Material Description": "S197*************** N2    KFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "4.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002726",
    "Material Description": "S3517***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.96",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.96",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.54",
    "VAR (%) - Approved SS vs S4": "-28.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002730",
    "Material Description": "S3516***************       ZFX175",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.53",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "4.53",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-0.97",
    "VAR (%) - Approved SS vs S4": "-17.64%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002738",
    "Material Description": "S4921.1***************       EFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.48",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.48",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.02",
    "VAR (%) - Approved SS vs S4": "-36.73%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002755",
    "Material Description": "S4915*************** N2    ZFX907.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-8.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "\n ",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1002756",
    "Material Description": "S4914*************** N2    ZFX850",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.30",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "4.30",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.20",
    "VAR (%) - Approved SS vs S4": "-33.85%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1003011",
    "Material Description": "S2652***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "3.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.00",
    "VAR (%) - Approved SS vs S4": "-40.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1003042",
    "Material Description": "S2817*************** N2    XFX17",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "6.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.70",
    "VAR (%) - Approved SS vs S4": "-43.93%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "LUCY LI",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1003061",
    "Material Description": "S2436*************** N2    ZFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "5.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-6.23",
    "VAR (%) - Approved SS vs S4": "-53.11%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1003094",
    "Material Description": "S7603***************      LXFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-10.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "BARBARA GENTE",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1008081",
    "Material Description": "S2731.1*************** N2    EFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.00",
    "VAR (%) - Approved SS vs S4": "-33.33%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1021745",
    "Material Description": "S4127***************       XFX20",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "3.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1026632",
    "Material Description": "S4726.1***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.02",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "4.02",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.98",
    "VAR (%) - Approved SS vs S4": "-33.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1035831",
    "Material Description": "S2991.4*************** N2    XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "8.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "8.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1039214",
    "Material Description": "S2516.1*************** N2    ZFZ25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.67",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "2.67",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-3.83",
    "VAR (%) - Approved SS vs S4": "-58.92%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1045802",
    "Material Description": "S3179.1***************       ZFX750",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "4.50",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.00",
    "VAR (%) - Approved SS vs S4": "-18.18%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1045805",
    "Material Description": "S3179.2***************       ZFX850",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "5.00",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "2.00",
    "VAR (%) - Approved SS vs S4": "66.67%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1098807",
    "Material Description": "R302***************       XFX50",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "4.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1116506",
    "Material Description": "S3503.2***************       ZFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "1.82",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "1.82",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-0.68",
    "VAR (%) - Approved SS vs S4": "-27.20%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1119807",
    "Material Description": "S2391.5*************** N2    ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.27",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.27",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.23",
    "VAR (%) - Approved SS vs S4": "-40.55%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Rejected",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1160920",
    "Material Description": "R117***************       XFX182.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "3.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.00",
    "VAR (%) - Approved SS vs S4": "-40.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1171929",
    "Material Description": "A10041***************       ZFX1",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-11.46",
    "VAR (%) - Approved SS vs S4": "-74.13%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1171997",
    "Material Description": "S1233***************       ZFX15",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.50",
    "Coverage Profile (wk) - Approved": "4.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "LUCY LI",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1172037",
    "Material Description": "S2255.1***************       ZFX226.8",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "6.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.50",
    "VAR (%) - Approved SS vs S4": "9.09%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Round up to 6",
    "Approver": "LUCY LI",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1172041",
    "Material Description": "A30103***************       HFZ204.12",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "",
    "VAR (wk) - Approved SS vs S4": "-6.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Approved as part of Set 1 ING. ",
    "Approver": "LUCY LI",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1172075",
    "Material Description": "S803*************** N2    XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "2.00",
    "VAR (%) - Approved SS vs S4": "100.00%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1172177",
    "Material Description": "S4911.9*************** N2    ZFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.00",
    "VAR (%) - Approved SS vs S4": "-61.54%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1172201",
    "Material Description": "S1521.8*************** N2    ZFX907.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-3.50",
    "VAR (%) - Approved SS vs S4": "-46.67%",
    "User Selected Choice": "Safety Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1174104",
    "Material Description": "S405***************       ZFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "5.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.78",
    "VAR (%) - Approved SS vs S4": "-35.73%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1184639",
    "Material Description": "A10181***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "5.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "1.00",
    "VAR (%) - Approved SS vs S4": "25.00%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Round to 5",
    "Approver": "LUCY LI",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1273096",
    "Material Description": "S3005.7***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-3.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1351696",
    "Material Description": "S2907.4***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.17",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "4.17",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.33",
    "VAR (%) - Approved SS vs S4": "-24.18%",
    "User Selected Choice": "IBP Stock",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1356447",
    "Material Description": "S7059.2***************    PK KFX17.05",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "6.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "BARBARA GENTE",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1403422",
    "Material Description": "S3515.7*************** N2    XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1403425",
    "Material Description": "S2793.7*************** N2    XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.60",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "2.60",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.40",
    "VAR (%) - Approved SS vs S4": "-48.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1408232",
    "Material Description": "S2392.3***************       KFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1412072",
    "Material Description": "S2434.7***************    PK ZFX166",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "5.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1417895",
    "Material Description": "S2064.3***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "7.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "7.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-6.46",
    "VAR (%) - Approved SS vs S4": "-47.99%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1423212",
    "Material Description": "S2118.1***************       XFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.51",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.51",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.99",
    "VAR (%) - Approved SS vs S4": "-36.18%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1438432",
    "Material Description": "S2434.7***************    PK ZFX747",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "2.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1451120",
    "Material Description": "S7603***************    PKLZFX18.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.50",
    "VAR (%) - Approved SS vs S4": "-42.86%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "BARBARA GENTE",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1491325",
    "Material Description": "S3174.3***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1506700",
    "Material Description": "S2432.6***************       XFX200",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "",
    "VAR (wk) - Approved SS vs S4": "-5.00",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Approved as part of Set 1 ING. ",
    "Approver": "JESUS GARCIA",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1507448",
    "Material Description": "S3935.7***************       XFX150",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "2.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1511298",
    "Material Description": "S2395.6***************       XFX20",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.00",
    "VAR (%) - Approved SS vs S4": "-50.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1532094",
    "Material Description": "S2473.8***************       ZFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.11",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "4.11",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.89",
    "VAR (%) - Approved SS vs S4": "-54.33%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1532095",
    "Material Description": "S2939.4***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.23",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "5.23",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.77",
    "VAR (%) - Approved SS vs S4": "-34.63%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1537696",
    "Material Description": "S2017.7***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1537698",
    "Material Description": "S7051.2***************    PK XFA10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.42",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.42",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-0.58",
    "VAR (%) - Approved SS vs S4": "-14.50%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "BARBARA GENTE",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1551297",
    "Material Description": "S3881.3***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1555294",
    "Material Description": "S3535.4***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.53",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.53",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.97",
    "VAR (%) - Approved SS vs S4": "-35.82%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1561596",
    "Material Description": "S3612.6***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "3.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.50",
    "VAR (%) - Approved SS vs S4": "-60.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1586195",
    "Material Description": "S2935.3***************       KFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1602797",
    "Material Description": "S2798.7***************       ZFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.71",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "2.71",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.29",
    "VAR (%) - Approved SS vs S4": "-45.80%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1617514",
    "Material Description": "S413    ***************       XFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1619094",
    "Material Description": "S7603***************      LZFX1000",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.00",
    "Coverage Profile (wk) - Approved": "3.00",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.00",
    "VAR (%) - Approved SS vs S4": "-25.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "BARBARA GENTE",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1619896",
    "Material Description": "R112.1***************    DR XFX181.4",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "10.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "10.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-12.40",
    "VAR (%) - Approved SS vs S4": "-55.36%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1635510",
    "Material Description": "S2458.7***************    PK ZFX132.8",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.50",
    "Coverage Profile (wk) - Approved": "2.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1641098",
    "Material Description": "S1809.3***************       XFA10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.50",
    "VAR (%) - Approved SS vs S4": "-38.46%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1641101",
    "Material Description": "S2609***************       XFX11.34",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1649007",
    "Material Description": "R135***************       KFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1649461",
    "Material Description": "S2461.3***************       XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.10",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.10",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.90",
    "VAR (%) - Approved SS vs S4": "-61.25%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1654212",
    "Material Description": "S3179***************    IB KFA500",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.57",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "6.57",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-10.11",
    "VAR (%) - Approved SS vs S4": "-60.61%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1655696",
    "Material Description": "S3806.1***************       ZFX900",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "2.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.50",
    "VAR (%) - Approved SS vs S4": "-37.50%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1655704",
    "Material Description": "S4744.3***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.50",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "3.50",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.50",
    "VAR (%) - Approved SS vs S4": "-30.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1656196",
    "Material Description": "S3947.1***************       ZFX180",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.39",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "2.39",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.61",
    "VAR (%) - Approved SS vs S4": "-52.20%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1664747",
    "Material Description": "S2507***************       XFX800",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "",
    "VAR (wk) - Approved SS vs S4": "-2.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Approved as part of Set 1 ING. ",
    "Approver": "JESUS GARCIA",
    "Set": "1",
    "Writeback Date": "8/27/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1689495",
    "Material Description": "S2507.7***************       ZFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "0.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-3.50",
    "VAR (%) - Approved SS vs S4": "-100.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1708218",
    "Material Description": "S2403.4***************    IB ZFX800",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.62",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.62",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-1.88",
    "VAR (%) - Approved SS vs S4": "-34.18%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1712743",
    "Material Description": "S277    ***************       XFX10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "4.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "4.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-14.92",
    "VAR (%) - Approved SS vs S4": "-78.86%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1715623",
    "Material Description": "S2938***************       ZFX907.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "5.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.50",
    "VAR (%) - Approved SS vs S4": "-33.33%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1715894",
    "Material Description": "S2475.4***************       XFA10",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "9.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "9.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-8.44",
    "VAR (%) - Approved SS vs S4": "-48.39%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1716802",
    "Material Description": "S3188.2***************       XFX500",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.68",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "5.68",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.32",
    "VAR (%) - Approved SS vs S4": "-29.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1721018",
    "Material Description": "S3334.4***************    DR XFA750",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "1.69",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "1.69",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-4.31",
    "VAR (%) - Approved SS vs S4": "-71.83%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1722556",
    "Material Description": "S3883***************       HFX500",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "5.50",
    "Coverage Profile (wk) - Approved": "3.50",
    "Safety Time (wk)- Approved": "2.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1723197",
    "Material Description": "S3933.9***************    DR XFX850",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.50",
    "Coverage Profile (wk) - Approved": "2.50",
    "Safety Time (wk)- Approved": "",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.00",
    "VAR (%) - Approved SS vs S4": "-44.44%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1734841",
    "Material Description": "R203***************       ZFZ907.2",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "6.00",
    "Coverage Profile (wk) - Approved": "0.00",
    "Safety Time (wk)- Approved": "6.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.50",
    "VAR (%) - Approved SS vs S4": "-29.41%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1774698",
    "Material Description": "S411*************** N2    XFX210",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "2.00",
    "Coverage Profile (wk) - Approved": "2.00",
    "Safety Time (wk)- Approved": "0.00",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "0.00",
    "VAR (%) - Approved SS vs S4": "0.00%",
    "User Selected Choice": "",
    "End User (Final Action)": "Overwrite in IBP",
    "Approver Comments": "Add comments if necessary",
    "Approver": "Sharon Melvin",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  },
  {
    "Approval status": "3. Safety Stock Approved",
    "End User": "Aoife McGarry",
    "Material Plant": "5040",
    "Material Number": "1775704",
    "Material Description": "S1366.3*************** N2    XFX25",
    "S4 Consolidated Safety Stock (wk)": "",
    "Consolidated Safety Stock (wk) - Approved": "3.83",
    "Coverage Profile (wk) - Approved": "",
    "Safety Time (wk)- Approved": "3.83",
    "Safety Stock (Qty) - Approved": "0.00",
    "VAR (wk) - Approved SS vs S4": "-2.89",
    "VAR (%) - Approved SS vs S4": "-43.01%",
    "User Selected Choice": "",
    "End User (Final Action)": "No Overwrite is required",
    "Approver Comments": "Add comments if necessary",
    "Approver": "JESUS GARCIA",
    "Set": "2",
    "Writeback Date": "9/25/2025",
    "Item Type": "Item",
    "Weekly Demand (Qty)": ""
  }
]

export const mockInputView = [
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002588",
        "Material Description": "S7053***************    DR ZFX25",
        "S4 Consolidated Safety Stock (wk)": "4.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.50",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "2.50",
        "IO Coverage (Weeks) (Rounded)": "5.50",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.00",
        "Variation (%) - IO vs S4": "22.22%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "BARBARA GENTE",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002635",
        "Material Description": "S2949***************       ZFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.34",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.34",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.16",
        "Variation (%) - IO vs S4": "-21.09%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002656",
        "Material Description": "S4423***************       ZFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.44",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "2.44",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.06",
        "Variation (%) - IO vs S4": "-55.64%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002689",
        "Material Description": "S197*************** N2    XFX50",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.72",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "2.72",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.28",
        "Variation (%) - IO vs S4": "-32.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002715",
        "Material Description": "S4131***************       XFX10",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-5.50",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002837",
        "Material Description": "S705***************    DR XFA25",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.29",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "6.29",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.29",
        "Variation (%) - IO vs S4": "57.25%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "BARBARA GENTE",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002943",
        "Material Description": "S1141*************** N2    ZFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.90",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "1.90",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.60",
        "Variation (%) - IO vs S4": "-65.45%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002958",
        "Material Description": "S1359***************       XFX16",
        "S4 Consolidated Safety Stock (wk)": "4.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.74",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "5.74",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.24",
        "Variation (%) - IO vs S4": "27.56%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1002960",
        "Material Description": "S1357*************** N2    ZFX177",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.20",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.20",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.30",
        "Variation (%) - IO vs S4": "-23.64%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1003005",
        "Material Description": "S2515***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "8.29",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "8.29",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.29",
        "Variation (%) - IO vs S4": "38.17%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1003082",
        "Material Description": "S814***************       PFX1",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "2.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-6.00",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1006498",
        "Material Description": "S2071.7***************       ZFZ16",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.28",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.28",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.22",
        "Variation (%) - IO vs S4": "-4.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1014729",
        "Material Description": "S2991.6***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.15",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "6.15",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.15",
        "Variation (%) - IO vs S4": "2.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1015688",
        "Material Description": "S3041.8***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.83",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.83",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.67",
        "Variation (%) - IO vs S4": "-12.18%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1021767",
        "Material Description": "S410***************       XFX11.34",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.37",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.37",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.63",
        "Variation (%) - IO vs S4": "-10.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1030975",
        "Material Description": "S444***************       ZFX2.5",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.23",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "5.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "4.23",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.27",
        "Variation (%) - IO vs S4": "-23.09%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1030976",
        "Material Description": "S446***************       ZFX11.34",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.91",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.91",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.91",
        "Variation (%) - IO vs S4": "95.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1045804",
        "Material Description": "S3801.4***************    IB ZFX900",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "7.87",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "7.87",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.87",
        "Variation (%) - IO vs S4": "96.75%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1066203",
        "Material Description": "S2951.1***************    PK XFX10",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "5.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.50",
        "Variation (%) - IO vs S4": "-23.08%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1093200",
        "Material Description": "S2937.2***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "3.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.27",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "2.27",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.23",
        "Variation (%) - IO vs S4": "-35.14%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1097210",
        "Material Description": "S427***************       XFX10",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.13",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "6.13",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.13",
        "Variation (%) - IO vs S4": "53.25%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1101610",
        "Material Description": "S4131.1***************       XFX3",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "27.03",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "2.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "27.03",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "20.53",
        "Variation (%) - IO vs S4": "315.85%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1110194",
        "Material Description": "S2078.4***************       ZFX180",
        "S4 Consolidated Safety Stock (wk)": "7.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.56",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "3.56",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.94",
        "Variation (%) - IO vs S4": "-52.53%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-7.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1113610",
        "Material Description": "S4121***************       XFX20",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.18",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "9.18",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.68",
        "Variation (%) - IO vs S4": "66.91%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1160200",
        "Material Description": "R115***************       PFX43.75",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1171950",
        "Material Description": "S1571.2***************       ZFX5",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.99",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.99",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.99",
        "Variation (%) - IO vs S4": "99.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1171951",
        "Material Description": "S1571.3***************       ZFX5",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.35",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.35",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.35",
        "Variation (%) - IO vs S4": "67.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1171977",
        "Material Description": "S1245*************** N2    XFX16",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.45",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "9.45",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.95",
        "Variation (%) - IO vs S4": "45.38%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172060",
        "Material Description": "S2669.6***************       ZFX11.34",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.27",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.27",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.27",
        "Variation (%) - IO vs S4": "163.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172071",
        "Material Description": "S437***************       XFX1000G",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "8.60",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "8.60",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.10",
        "Variation (%) - IO vs S4": "32.31%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172072",
        "Material Description": "S4505***************       XFA12.5",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.16",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "5.16",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.16",
        "Variation (%) - IO vs S4": "29.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172074",
        "Material Description": "S4501*************** N2    XFX25",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "1.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.00",
        "Variation (%) - IO vs S4": "-50.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172081",
        "Material Description": "S4552*************** N2    ZFX5",
        "S4 Consolidated Safety Stock (wk)": "13.46",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.04",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "5.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.04",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-9.42",
        "Variation (%) - IO vs S4": "-69.99%",
       "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-13.46",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172093",
        "Material Description": "S4502*************** N2    XFX5",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "1.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.00",
        "Variation (%) - IO vs S4": "-50.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172098",
        "Material Description": "S4171*************** N2    ZFX1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.98",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "6.98",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "4.98",
        "Variation (%) - IO vs S4": "249.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172102",
        "Material Description": "S4371***************       XFX1",
        "S4 Consolidated Safety Stock (wk)": "37.09",
        "IO Consolidated Safety Stock (wk) - Rounded": "8.67",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.50",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "8.67",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-28.42",
        "Variation (%) - IO vs S4": "-76.62%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-37.09",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172103",
        "Material Description": "S4471***************       ZFX1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.15",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "2.15",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.15",
        "Variation (%) - IO vs S4": "7.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172107",
        "Material Description": "S4182*************** N2    XFX1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.15",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "9.15",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "7.15",
        "Variation (%) - IO vs S4": "357.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
         "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172112",
        "Material Description": "S4224*************** N2    ZFX5",
        "S4 Consolidated Safety Stock (wk)": "10.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "5.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-5.50",
        "Variation (%) - IO vs S4": "-52.38%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-10.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172113",
        "Material Description": "S448***************       ZFX5",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.66",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "6.66",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "4.66",
        "Variation (%) - IO vs S4": "233.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172115",
        "Material Description": "S8061*************** N2    XFX0.5",
        "S4 Consolidated Safety Stock (wk)": "42.79",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.15",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "1.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "9.15",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-33.64",
        "Variation (%) - IO vs S4": "-78.62%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-42.79",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172127",
        "Material Description": "S4129.7***************       ZFX1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.50",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.50",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.50",
        "Variation (%) - IO vs S4": "175.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172135",
        "Material Description": "S4183*************** N2    XFX1",
        "S4 Consolidated Safety Stock (wk)": "13.53",
        "IO Consolidated Safety Stock (wk) - Rounded": "7.20",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "1.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "7.20",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-6.33",
        "Variation (%) - IO vs S4": "-46.78%",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-13.53",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172137",
        "Material Description": "S4681***************       XFX1",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.12",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "9.12",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.62",
        "Variation (%) - IO vs S4": "40.31%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
      "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172138",
        "Material Description": "S4373***************       XFX0.5",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.88",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.88",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.88",
        "Variation (%) - IO vs S4": "144.00%",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172140",
        "Material Description": "S4131.6*************** N2    ZFX1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.72",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.72",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.72",
        "Variation (%) - IO vs S4": "186.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172141",
        "Material Description": "S4131.7*************** N2    ZFZ1",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.72",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.72",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.72",
        "Variation (%) - IO vs S4": "186.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172164",
        "Material Description": "S402*************** N2    ZFX11.34",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "9.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "9.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "7.00",
        "Variation (%) - IO vs S4": "350.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172165",
        "Material Description": "S4508*************** N2    XFX11.34",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.37",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.37",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.37",
        "Variation (%) - IO vs S4": "118.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1172238",
        "Material Description": "S5162***************       ZFX20",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.27",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "5.27",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.27",
        "Variation (%) - IO vs S4": "163.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1184641",
        "Material Description": "A40003***************       ZFX25",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.31",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "1.31",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.69",
        "Variation (%) - IO vs S4": "-34.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1217513",
        "Material Description": "S2611***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.52",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "2.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "1.52",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.48",
        "Variation (%) - IO vs S4": "-24.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1337101",
        "Material Description": "R130***************       XFX180",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-5.50",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1342001",
        "Material Description": "S2458.7***************       ZFX900",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "16.42",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "16.42",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "10.92",
        "Variation (%) - IO vs S4": "198.55%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1347051",
        "Material Description": "S2952.3***************       PFX800",
        "S4 Consolidated Safety Stock (wk)": "1.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "1.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.00",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-1.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
       "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1356446",
        "Material Description": "S2458.8***************       KFA50.1",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "29.51",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "29.51",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "29.51",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1390443",
        "Material Description": "S7059.2***************    PK CFX17.05",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-6.00",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "BARBARA GENTE",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1392903",
        "Material Description": "S2935.6***************       PFX10",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1392904",
        "Material Description": "S2398.9***************       PFX25",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1397294",
        "Material Description": "S2434.6***************       PFX18",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1398594",
        "Material Description": "R505***************       KFZ1",
        "S4 Consolidated Safety Stock (wk)": "8.70",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.21",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-8.70",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-8.70",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1398596",
        "Material Description": "R504***************       KFZ11.34",
        "S4 Consolidated Safety Stock (wk)": "8.54",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "13.40",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-8.54",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-8.54",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1515628",
        "Material Description": "S2938.9***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "3.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.01",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "6.01",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.51",
        "Variation (%) - IO vs S4": "71.71%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1561595",
        "Material Description": "S4741.4***************       ZFX25",
        "S4 Consolidated Safety Stock (wk)": "3.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.58",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "3.58",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.58",
        "Variation (%) - IO vs S4": "19.33%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1563499",
        "Material Description": "S3174.8***************       XFA25",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.14",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "2.14",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.86",
        "Variation (%) - IO vs S4": "-46.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1563510",
        "Material Description": "S2798.3***************       ZFX10",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.69",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "3.00",
        "IO Safety Time (Weeks) (Rounded)": "4.69",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.81",
        "Variation (%) - IO vs S4": "-27.85%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1588296",
        "Material Description": "S4726.7***************       KFX25",
        "S4 Consolidated Safety Stock (wk)": "3.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.71",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "1.71",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.29",
        "Variation (%) - IO vs S4": "-43.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1588297",
        "Material Description": "S3612.6***************       KFX25",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.21",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "2.21",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.79",
        "Variation (%) - IO vs S4": "-63.17%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1617513",
        "Material Description": "S413***************       XFX20",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "7.04",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "7.04",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.04",
        "Variation (%) - IO vs S4": "76.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1618196",
        "Material Description": "R111.1***************    DR XFX181.43",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.49",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "2.49",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.49",
        "Variation (%) - IO vs S4": "24.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1619702",
        "Material Description": "S197*************** N2    XFX100",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.42",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "1.42",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.58",
        "Variation (%) - IO vs S4": "-64.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1641100",
        "Material Description": "S2409.1***************       XFA11.34",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.30",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "2.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "2.30",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.30",
        "Variation (%) - IO vs S4": "15.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1655702",
        "Material Description": "S4938.8***************       ZFA25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.90",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "2.90",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.60",
        "Variation (%) - IO vs S4": "-47.27%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1656742",
        "Material Description": "S404***************       XFX2",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.28",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "6.28",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "6.28",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1657313",
        "Material Description": "S414***************       ZFX20",
        "S4 Consolidated Safety Stock (wk)": "5.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "7.94",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "5.00",
        "IO Safety Time (Weeks) (Rounded)": "7.94",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.94",
        "Variation (%) - IO vs S4": "58.80%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1664720",
        "Material Description": "S418*************** N2    ZFX10",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.37",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.37",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "2.37",
        "Variation (%) - IO vs S4": "118.50%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1679140",
        "Material Description": "R114.1***************       ZFZ50",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.26",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "2.26",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.26",
        "Variation (%) - IO vs S4": "13.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1697335",
        "Material Description": "S2269.3***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.48",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.48",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.02",
        "Variation (%) - IO vs S4": "-36.73%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1702906",
        "Material Description": "S3385.1***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.63",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "2.63",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.37",
        "Variation (%) - IO vs S4": "-34.25%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1706016",
        "Material Description": "S189***************       ZFX180",
        "S4 Consolidated Safety Stock (wk)": "4.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "1.52",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "4.00",
        "IO Safety Time (Weeks) (Rounded)": "1.52",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.48",
        "Variation (%) - IO vs S4": "-62.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-4.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "Sharon Melvin",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1706917",
        "Material Description": "S2256*************** N2    HFX218",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "2.78",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "2.78",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.22",
        "Variation (%) - IO vs S4": "-53.67%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1708238",
        "Material Description": "S2322*************** N2    ZFX1",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.86",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.86",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.64",
        "Variation (%) - IO vs S4": "-25.23%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1727672",
        "Material Description": "S5193***************       ZFX10",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.95",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.95",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.05",
        "Variation (%) - IO vs S4": "-34.17%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1729396",
        "Material Description": "S4999*************** N2    XFX17",
        "S4 Consolidated Safety Stock (wk)": "12.80",
        "IO Consolidated Safety Stock (wk) - Rounded": "10.45",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "17.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "10.45",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.35",
        "Variation (%) - IO vs S4": "-18.36%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-12.80",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1734065",
        "Material Description": "S2775.4***************    DR XFX20",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "12.07",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "12.07",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "6.57",
        "Variation (%) - IO vs S4": "119.45%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1737700",
        "Material Description": "S3138.5***************       XFX10",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.38",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.38",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.38",
        "Variation (%) - IO vs S4": "69.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1772068",
        "Material Description": "S2802.1***************       XFX17",
        "S4 Consolidated Safety Stock (wk)": "22.19",
        "IO Consolidated Safety Stock (wk) - Rounded": "16.70",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "510.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "16.70",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-5.49",
        "Variation (%) - IO vs S4": "-24.74%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-22.19",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "LUCY LI",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1796025",
        "Material Description": "S3863.3***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "3.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.25",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "5.25",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "1.75",
        "Variation (%) - IO vs S4": "50.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1800810",
        "Material Description": "S2829.8***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "2.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.50",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "6.50",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "4.50",
        "Variation (%) - IO vs S4": "225.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-2.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1829596",
        "Material Description": "S293***************       XFX200",
        "S4 Consolidated Safety Stock (wk)": "5.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "4.67",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "4.67",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-0.33",
        "Variation (%) - IO vs S4": "-6.60%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1866894",
        "Material Description": "S4726.7***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "3.53",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "3.53",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-2.97",
        "Variation (%) - IO vs S4": "-45.69%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1899824",
        "Material Description": "S3792.8***************       ZFZ25",
        "S4 Consolidated Safety Stock (wk)": "6.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "6.00",
        "IO Safety Time (Weeks) (Rounded)": "5.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-1.00",
        "Variation (%) - IO vs S4": "-16.67%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1899826",
        "Material Description": "S3483.4***************       ZFZ25",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-6.50",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1901094",
        "Material Description": "S3595.4***************       ZFZ25",
        "S4 Consolidated Safety Stock (wk)": "6.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "4.50",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-6.50",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-6.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "1965695",
        "Material Description": "S2437.5***************       XFX25",
        "S4 Consolidated Safety Stock (wk)": "5.50",
        "IO Consolidated Safety Stock (wk) - Rounded": "5.50",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "3.50",
        "IO Coverage (Weeks) (Rounded)": "5.50",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "2.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-5.50",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "2005998",
        "Material Description": "S2938***************       KFX20",
        "S4 Consolidated Safety Stock (wk)": "3.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.80",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "3.00",
        "IO Safety Time (Weeks) (Rounded)": "6.80",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "3.80",
        "Variation (%) - IO vs S4": "126.67%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "2006127",
        "Material Description": "S3669.1***************       KFX20",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "6.80",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "6.80",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "6.80",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "2011652",
        "Material Description": "S3723.7***************       PFZ25",
        "S4 Consolidated Safety Stock (wk)": "0.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "0.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "0.00",
        "Variation (%) - IO vs S4": "0.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "0.00",
        "VAR (%) - End User Proposal vs S4": "0.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    },
    {
        "Approval status": "1. Reviewing IO Output",
        "End User": "Aoife McGarry",
        "Material Plant": "5040",
        "Material Number": "2011899",
        "Material Description": "S1633.5***************       PFZ25",
        "S4 Consolidated Safety Stock (wk)": "3.00",
        "IO Consolidated Safety Stock (wk) - Rounded": "0.00",
        "IO Material Type": "0.00",
        "S4 Safety Stock (Qty)": "0.00",
        "Safety Stock (Qty) - End User Proposal": "",
        "S4 Coverage Profile (wk)": "0.00",
        "IO Coverage (Weeks) (Rounded)": "0.00",
        "Coverage Profile (wk) - End User Proposal": "",
        "S4 Safety Time (wk)": "3.00",
        "IO Safety Time (Weeks) (Rounded)": "0.00",
        "Safety Time (wk) - End User Proposal": "",
        "Variation (wk) - IO vs S4": "-3.00",
        "Variation (%) - IO vs S4": "-100.00%",
        "End User Actions": "Please review the IBP IO proposal",
        "End User Comments": "Add comments if necessary",
        "VAR (wk) - End User Proposal vs S4": "-3.00",
        "VAR (%) - End User Proposal vs S4": "-100.00%",
        "Approver": "JESUS GARCIA",
        "Approval Required?": "Item",
        "Weekly Demand (Qty)": ""
    }
]
